// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spSearchRow {
    margin-bottom: 20px;
}

.spCount {
    font-size: 14px;
    color: var(--integration-text-color);
}

.spDataSourceItem {
    width: 168px;
    margin: 0px 20px 20px 0px;
}

    .spDataSourceItem > .spDataSourceIcon {
        height: 95px;
        border: 1px solid var(--integration-border-color);
        border-radius: 10px;
    }

    .spDataSourceItem.spDataSourceItem-selected > .spDataSourceIcon {
        border: 2px solid var(--integration-text-color);
    }

    .spDataSourceItem > .spDataSourceCaption {
        font-size: 15px;
        color: var(--integration-text-color);
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 8px 10px 0px 10px;
    }

.p-input-icon-left {
    font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.source.page.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;IAEI;QACI,YAAY;QACZ,iDAAiD;QACjD,mBAAmB;IACvB;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,eAAe;QACf,oCAAoC;QACpC,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,yBAAyB;IAC7B;;AAEJ;IACI,eAAe;AACnB","sourcesContent":[".spSearchRow {\n    margin-bottom: 20px;\n}\n\n.spCount {\n    font-size: 14px;\n    color: var(--integration-text-color);\n}\n\n.spDataSourceItem {\n    width: 168px;\n    margin: 0px 20px 20px 0px;\n}\n\n    .spDataSourceItem > .spDataSourceIcon {\n        height: 95px;\n        border: 1px solid var(--integration-border-color);\n        border-radius: 10px;\n    }\n\n    .spDataSourceItem.spDataSourceItem-selected > .spDataSourceIcon {\n        border: 2px solid var(--integration-text-color);\n    }\n\n    .spDataSourceItem > .spDataSourceCaption {\n        font-size: 15px;\n        color: var(--integration-text-color);\n        text-align: center;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin: 8px 10px 0px 10px;\n    }\n\n.p-input-icon-left {\n    font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
